<ngx-loading-bar [includeSpinner]="false" height="4px" color="#FF0000"></ngx-loading-bar>
<div class="pages">
  <div data-page="blog" class="page no-toolbar no-navbar">
    <div class="page-content">
      <div class="navbarpages">
        <div class="navbar_left">
          <a [routerLink]="['/menu']"><img src="./assets/images/icons/blue/menu.png"/></a>
        </div>
        <div class="navbar_center">
          <h2>{{ this.Ueberschrift }}</h2>

        </div>
        <div class="navbar_right"><a [routerLink]="['/user']" data-panel="right" class="open-panel"><img
        src="./assets/images/icons/blue/user.png" alt="" title=""/></a></div>
      </div>

      <div id="pages_maincontent">

        <a (click)="back()" class="backto" style="z-index: 99"><img src="./assets/images/icons/blue/back.png"
        style="position: absolute; top: 0px; left:0px;"/></a>
        <h2 style="width: 100%; text-align: center" class="post_title_single">{{PogsagItem.ort}}</h2>
        @if (PogsagItem.hinweis != '') {
          <div><h3 style="width: 100%; text-align: center" class="post_title_single">{{PogsagItem.hinweis}}</h3><br></div>
        }
        <!-- Hier die DiveraDaten, wenn vorhanden! -->

        @if (PogsagItem.diveradata !== '') {
          <div >
            <h3><u><b>Alarminfos über Divera</b></u></h3>
            <div [innerHTML]="PogsagItem.diveradata"></div>
          </div>
        }



        <div class="page_content">
          <div>
            <h3><u><b>Historie an dem Alarmort</b></u></h3>
            <h1 (click)="this.showStichwort = !this.showStichwort;" style="text-decoration: underline black">Stichwörter</h1>
            @if (this.showStichwort == true) {
              <table (click)="this.showStichwort = !this.showStichwort;" style="margin-left:auto;margin-right:auto; border: #1b1b25 solid 1px; width: 90%">
                <tr style="border-bottom: black solid 2px;">
                  <td style="padding-right:20px; font-weight:bold; width: 30%;">Zeitpunkt</td>
                  <td style="font-weight:bold;">Stichwort</td>
                </tr>
                @for (Item of PogsagItem['alarmstichwort']; track Item) {
                  <tr
                    style="border-bottom: black solid 1px;">
                    <td [innerHTML]="Item[1]"></td>
                    <td>{{ Item[0]}}</td>
                  </tr>
                }
              </table>
            }
            <br>
              <h1 (click)="this.showEinheiten = !this.showEinheiten;" style="text-decoration: underline black">Einheiten</h1>
              @if (this.showEinheiten == true) {
                <table (click)="this.showEinheiten = !this.showEinheiten;"   style="margin-left:auto;margin-right:auto; border: #1b1b25 solid 1px; width: 90%">
                  <tr style="border-bottom: black solid 2px;">
                    <td style="padding-right:20px; font-weight:bold; width: 30%;">Zeitpunkt</td>
                    <td style="font-weight:bold;">Einheiten</td>
                  </tr>
                  @for (Item of PogsagItem['alarmierte_einheiten']; track Item) {
                    <tr
                      style="border-bottom: black solid 1px;">
                      <td [innerHTML]="Item[1]"></td>
                      <td>{{ Item[0]}}</td>
                    </tr>
                  }
                </table>
              }
              <br>
                @if (PogsagItem.koordinateX !== '' && PogsagItem.koordinateX !== '0') {
                  <google-map
                    width="100%"
                    style="height: 100% !important;"
                    [center]="center"
                    >
                    <map-marker
                      [position]="marker.position"
                      [options]="marker.options"
                    ></map-marker>
                  </google-map>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
